const UsersPage = () => {
    return <div>Users</div>
}

export default UsersPage;

